export default "__VITE_ASSET__CCneDWJC__"